import React from 'react';
import { Link } from 'react-router-dom';
import Event1 from '../../assets/images/blog-mini-2.jpg'
import Event2 from '../../assets/images/blog-mini-1.jpg'
const Footer = () => {
  return (
    <div className="container-fluid footer pt-5 wow fadeIn" data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="row g-4 footer-inner">
          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item mt-5">
              <h4 className="text-light mb-4">Harvey<span className="text-primary">Masjid</span></h4>
              <p className="mb-4 text-secondary">
                Established in 1995, Harvey Masjid serves as a spiritual home for Muslims in the Harvey area,
                offering daily prayers, Islamic education and community services.
              </p>
              <div className="d-flex">
                <a href="#" className="btn btn-dark me-2">
                  <i className="fab fa-apple me-1"></i> App
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.wasuan8.Harveymasjid" className="btn btn-dark">
                  <i className="fab fa-google-play me-1"></i> Play
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item mt-5">
              <h4 className="text-light mb-4">Our Mosque</h4>
              <div className="d-flex flex-column">
                <h6 className="text-secondary mb-0">Our Address</h6>
                <div className="d-flex align-items-center border-bottom py-4">
                  <span className="flex-shrink-0 btn-square bg-primary me-3 p-4">
                    <i className="fa fa-map-marker-alt text-dark"></i>
                  </span>
                  <a href="https://www.google.com/maps/place/15200+Broadway+Ave,+Harvey,+IL+60426,+USA/@41.6134323,-87.647534,620m/data=!3m2!1e3!4b1!4m6!3m5!1s0x880e224c4716b4b3:0xb659863a9a857558!8m2!3d41.6134283!4d-87.6449591!16s%2Fg%2F11ckqm6ygw?entry=ttu&g_ep=EgoyMDI1MDYwMi4wIKXMDSoASAFQAw%3D%3D" className="text-body">
                    15200 Broadway Ave, Harvey, IL 60426, United States
                  </a>
                </div>
                <h6 className="text-secondary mt-4 mb-0">Contact Us</h6>
                <div className="d-flex align-items-center py-4">
                  <span className="flex-shrink-0 btn-square bg-primary me-3 p-4">
                    <i className="fa fa-phone-alt text-dark"></i>
                  </span>
                  <a href="tel:+1234567890" className="text-body">+1 (234) 567-8900</a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item mt-5">
              <h4 className="text-light mb-4">Quick Links</h4>
              <div className="d-flex flex-column align-items-start">
                <Link to="/" className="text-body mb-2">
                  <i className="fa fa-check text-primary me-2"></i>Home
                </Link>
                <Link to="/about" className="text-body mb-2">
                  <i className="fa fa-check text-primary me-2"></i>About Us
                </Link>
                <Link to="/contact" className="text-body mb-2">
                  <i className="fa fa-check text-primary me-2"></i>Contact Us
                </Link>
                <Link to="/events" className="text-body mb-2">
                  <i className="fa fa-check text-primary me-2"></i>Events Calendar
                </Link>
                <Link to="/donate" className="text-body mb-2">
                  <i className="fa fa-check text-primary me-2"></i>Donations
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item mt-5">
              <h4 className="text-light mb-4">Upcoming Event</h4>
              <div className="d-flex border-bottom border-secondary py-4">
                <img src={Event2} className="img-fluid flex-shrink-0" alt="Community Iftar" />
                <div className="ps-3">
                  <p className="mb-0 text-muted">10 Apr 2024</p>
                  <Link to="/events" className="text-body">Community Iftar Program</Link>
                </div>
              </div>
              <div className="d-flex py-4">
                <img src={Event1} className="img-fluid flex-shrink-0" alt="Quran Competition" />
                <div className="ps-3">
                  <p className="mb-0 text-muted">20 Apr 2024</p>
                  <Link to="/events" className="text-body">Annual Quran Competition</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-4">
        <div className="border-top border-secondary pb-4"></div>
        <div className="row">
          <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
            &copy; <Link to="#" className="border-bottom">Harvey Masjid</Link>,<a className="text-md-end" >All Right Reserved.</a> 
          </div>
          <div className="col-md-6 text-center text-md-end">
            Designed By <a className="border-bottom" href="#">TheAMDigital</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;